<template>
  <div id="app">
    <loadingscreen :isloading="isloading" />
    <div v-if="!isloading">
      <div class="top-nav-bar">

        <div class="container">

          <div id="top-nav-header">
            <!-- <div class="row no-gutters">
              <b-col cols="3" lg="2" md="3">
                <div class="logo-box-wrapper">
                  <div class="logo-box">
                     <img   src="@/assets/images/satyamev-jayate.png" class="img-logo" /> //
                  </div>

                </div>

              </b-col>

              <b-col cols="8" lg="8" md="6" style="text-align:center" class="marathi header-text d-none d-md-block">
                <div>
                  <img src="@/assets/images/satyamev-jayate.png"
                    style="max-width: 111px; padding:10px; margin: 0px 40px 0px 0px;" class="img-logo" />
                  <img src="@/assets/images/logo.png" style="margin: 0px 40px 0px 40px;" class="img-logo" />
                  <img src="@/assets/images/top_image2.png" style="max-width: 111px; margin: 0px 40px 0px 40px;"
                    class="img-logo" />

                </div>

              </b-col>
              <b-col cols="5" lg="2" md="3" style="text-align:right">
                <div class="logo-box-wrapper">
                  <div class="logo-box2">
                     <img src="@/assets/images/Azadi.png"  class="img-logo"/>//
                    <img src="@/assets/images/top_image2.png"  class="img-logo"/> //

                  </div>

                </div>

              </b-col>
            </div> -->

            <!-- row ends-->

            <p class="text-sm marathi">महाराष्ट्र राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</p>
          </div>
          <b-container fluid>
            <b-row>
              <b-col>
                <div class="bg-blue">
                  <b-row>
                    <b-col md="2">
                      <b-row>
                        <b-col>
                          <img src="@/assets/images/satyamev-jayate.png"
                    style="max-width: 111px; padding:10px; margin: 0px 40px 0px 0px;" class="img-logo1" />
                        </b-col>
                      </b-row>
                      
                    <!-- <img src="@/assets/images/logo.png" style="margin: 0px 40px 0px 40px;" class="img-logo" /> -->
                    
                    </b-col>
                    <!-- <b-col md="2">
                      <b-row>
                        <b-col xl="4">
                          <img src="./assets/images/minster/eknath1.jpg" style="  width: 100%; border-radius:10px " width="100%" alt="">
                        </b-col>
                        <b-col xl="8">
                          <h4>
                            श्री एकनाथ शिंदे
                          </h4>
                          <p>
                            माननीय मुख्यमंत्री,<br /> महाराष्ट्र राज्य
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="2">
                      <b-row>
                        <b-col xl="4">
                          <img src="./assets/images/minster/dev_.jpg" style="  width: 100%; border-radius:10px" width="100%" alt="">
                        </b-col>
                        <b-col xl="8">
                          <h4>
                            श्री देवेंद्र फडणवीस
                          </h4>
                          <p>
                            माननीय उपमुख्यमंत्री,<br> महाराष्ट्र राज्य
                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="2">
                      <b-row>
                        <b-col xl="4">
                          <img src="./assets/images/minster/3.jpg" style=" width: 100%; border-radius:10px" width="100%" alt="">
                        </b-col>
                        <b-col xl="8">
                          <h4>
                            श्री अजित पवार
                          </h4>
                          <p>
                            माननीय उपमुख्यमंत्री, <br> महाराष्ट्र राज्य

                          </p>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="2">
                      <b-row>
                        <b-col xl="4">
                          <img src="./assets/images/minster/4.jpg" style=" ;width: 100%; border-radius:10px" width="100%" alt="">
                        </b-col>
                        <b-col xl="8">
                          <h4>
                            श्री अतुल मोरेश्वर सावे
                          </h4>
                          <p>
                            माननीय मंत्री, इतर मागास बहुजन कल्याण महाराष्ट्र राज्य

                          </p>
                        </b-col>
                      </b-row>
                    </b-col> -->
                    <b-col md="2">
                      <b-row>
                        <b-col>
                          <img src="@/assets/images/top_image2.png" style="max-width: 100px; margin: 0px 40px 0px 40px;"
                      class="img-logo" />
                        </b-col>
                      </b-row>
                      
                    </b-col>


                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-container>
          <b-container>
            
            <b-row>
              <!-- <b-col class="col-md-6">
                <img src="@/assets/images/logo.png" style="margin: 0px 40px 0px 40px;" class="img-logo" />
  
                </b-col> -->
              
              <b-col xl="12" style="text-align:center" class="marathi header-text d-none d-md-block">
                <!-- <b-col>
              <img src="@/assets/images/logo.png" style="margin: 0px 40px 0px 40px;" class="img-logo" />

              </b-col> -->
                <h3 style="margin-top:21px; color:#000; font-weight:800; font-family: 'DV-TTSurekh_Normal';">महाराष्ट्र
                  राज्य इतर मागासवर्गीय वित्त आणि विकास महामंडळ मर्यादित</h3>
                <h6 style="color: rgb(0, 0, 0); font-weight:600"> ( महाराष्ट्र शासनाचा उपक्रम ) </h6>
                
                <h6 class="heading-marathi-2" style="color: #ac7601; font-weight:600;">उपकंपनी </h6>
                <h6 class="heading-marathi-2"> शामराव पेजे कोकण इतर मागासवर्ग आर्थिक विकास महामंडळ ( कार्यक्षेत्र - कोकण
                  विभाग )</h6>
                <h6 class="heading-marathi-2">जगद्ज्योती महात्मा बसवेश्वर आर्थिक विकास महामंडळ ( कार्यक्षेत्र - सर्व
                  जिल्हे )</h6>
                <h6 class="heading-marathi-2">संत काशिबा गुरव युवा आर्थिक विकास महामंडळ ( कार्यक्षेत्र - सर्व जिल्हे )
                </h6>
                <h6 style="color: rgb(0, 0, 0); font-weight:600">इतर मागास बहुजन कल्याण विभाग </h6>
                <h2 style="color: red; font-weight:700">"महिला स्वयंसिध्दी व्याज परतावा योजना"</h2>
                  <img src="@/assets/images/logo.png" style="position: absolute; top: -3%; left: 20%; width: 7%;" class="img-logo3" />

              </b-col>
            </b-row>
          </b-container>
          <!-- top-nav-header ends here -->

        </div>

        <!-- top header nav ends here -->

        <RegistrationNavbar v-if="isLoggedIn"></RegistrationNavbar>

      </div>
      <router-view />


    </div>

  </div>
</template>

<script>
import RegistrationNavbar from "@/components/RegistrationNavbar";
import loadingscreen from "./components/SplashScreen/LoadingScreen.vue";
export default {
  components: { RegistrationNavbar, loadingscreen },
  name: "App",
  methods: {
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
    login() {
      this.$router.replace("/");
    },
    setLanguage() {
      var temp_lang = document.getElementsByClassName("goog-te-combo")[0].value;
      var flang =
        temp_lang == "hi" ? "हिन्दी" : temp_lang == "mr" ? "मराठी" : "English";

      document.querySelector(".lang-bar a.dropdown-toggle").innerHTML = flang;
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.UserName;
    },
    RegType() {
      var nme = this.$store.getters.loggedUser;
      return nme.RegistrationType;
    },
    isloading() {

    }
  }
};
</script>

<style>
#app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #ab7806;
}

.navbarCustom {
  background-color: #ab7806 !important;
}

body {
  background: #e8eff9;
}

ul {
  padding: 0;
  margin: 0;
}

.top-land {
  /*border-bottom : solid 2px #ccc;*/
  padding-top: 10px;
  padding-bottom: 10px;
}

.navbar {
  padding: 0 !important;
  background: #a58a4e !important;
}

.navbar-brand {
  font-size: 12pt !important;
  color: #ccc !important;
}

.navbar-toggler {
  margin: 5px;
}

.container.sm {
  width: 90% !important;
  background: #ab7806;
  padding: 20px 10px;
}

/* #google_translate_element,
.skiptranslate {
  display: none;
} */

body {
  top: 0 !important;
}

@font-face {
  font-family: 'DV-TTSurekh_Normal';
  src: url(assets/webfonts/DV-TTSurekh_Normal.woff);
}

@import url("https://fonts.googleapis.com/css?family=Laila&display=swap");

.marathi {
  font-family: "Laila", serif;
}

.header-text h6 {
  font-weight: 400;
  margin-bottom: 5px;
  font-size: 23px;
}

.heading-marathi-2 {
  margin-top: 10px;
  color: #000000;
}

.header-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* UI changes by Akshay 19-08-2019 */
.top-nav-bar {
  /* background-color:#ec5624; */
  /* background-color: #fe46a5 ;
  background-image: url("assets/images/circles.png");*/
  /*background-image: linear-gradient(to right, rgb(93, 217, 226) , rgb(238, 238, 96)); */
  /*background-image: linear-gradient(to right, rgb(255, 255, 255), rgb(238, 181, 96));*/
  background-image: linear-gradient(#e2ab34, white, #e2ab34);
}

#top-text {
  font-size: 15px;
  text-align: center;
  padding-top: 7px;
  color: #fff;
}

#top-nav-header {
  color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
}

#top-nav-header .logo-box-wrapper {
  display: flex;
  width: fit-content;
  /*margin-top: 75px;*/
  margin-left: auto;
  margin-right: auto;
}

#top-nav-header .logo-box {
  max-width: 200px;
  max-height: 200px;
  padding-left: 15px;
  padding-right: 15px;
  display: -webkit-flex;
  /* Safari */
  -webkit-align-items: center;
  /* Safari 7.0+ */
  display: flex;
  align-items: left;
}

#top-nav-header .logo-box img {
  max-width: 111px;

}

#top-nav-header .logo-box2 img {
  max-width: 111px;

}

#top-nav-header .photo-box-wrap {
  display: -webkit-flex;
  /* Safari */

  display: flex;
  margin-top: 16px;
  padding-right: 5px;
}

#top-nav-header .photo-box {
  min-width: 40px;
  min-height: 40px;

  margin-right: 10px;
  max-height: 40px;
  max-width: 40px;
}

#top-nav-header .photo-box img {
  max-width: 100%;
  max-height: 100%;

  border: 2px solid #f3ff08;
}

#top-nav-header .content-box {
  height: fit-content;
}

.bg-blue {
  /*background-color: #d19a1f;*/
  background-image: linear-gradient(#ab7806, #dfbb6e, #ab7806);
  color: #fff !important;
  padding: 1%;
  margin: 1%;
  font-family: 'DV-TTSurekh_Normal';
}

.bg-blue img {
  border-radius: 5px;

}

.bg-blue p {
  color: #fff;
  font-family: 'DV-TTSurekh_Normal';
  padding: 2px;
}

.bg-blue h4 {
  font-weight: 600;
  font-size: 1.2rem;
  font-family: 'DV-TTSurekh_Normal';

}

#top-nav-header .photo-box-wrap .content-box h5 {
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
  color: #f3ff08;
  font-weight: bold;
}

#top-nav-header .photo-box-wrap .content-box p {
  font-size: 12px;
  line-height: 1.4;
  color: #fff;
}

#top-nav-header .logo-box-wrapper img.img-1 {
  height: 52px;
}

/* responsive styles */
@media screen and (max-width: 1442px) {
  .bg-blue h4 {
    font-size: 0.8rem;
  }
  .bg-blue p{
    font-size: 0.8rem;

  }
  img.img-logo{
    max-width: 71px !important;
  }
  img.img-logo1{
    max-width: 85px !important;
  }
  img.img-logo1{
  left: 12%;
  }
}
@media (max-width: 1199px) {
  #top-nav-header .photo-box-wrap .content-box h5 {
    font-size: 12px;
  }

  #top-nav-header .photo-box-wrap .content-box p {
    font-size: 10px;
  }
}
@media (max-width: 1030px) {
 
  img.img-logo3{
    position: absolute;
    top: -1%;
    left: 2% !important;
    width: 7%;
  }
}

@media (max-width: 991px) {
  #top-nav-header .hide-tab {
    display: none;
  }
}

@media (max-width: 767px) {
  #top-text {
    text-align: left;
    font-size: 14px;
  }
}

@media (max-width: 575px) {
  #top-text {
    padding-top: 32px;
    text-align: center;
  }
}

.footer-main {
  margin-top: auto;
  padding-top: 10px;
  padding-bottom: 10px;
  /*background-color: #d19a1f;*/
  background-color: #ab7806;
  text-align: right;
  bottom: 0;
  width: 100%;
}

.footer-main ul {
  width: fit-content;
  margin: auto;
}

.text-sm {
  display: none;
}

@media (max-width: 767px) {
  .text-sm {
    display: block;
    color: #fff;
    text-align: center;
    font-size: 15px;
    margin-top: 5px;
  }

  #top-nav-header .logo-box img {
    max-width: 75px;
    max-height: 75px;
  }
}

@media (max-width: 419px) {
  .text-sm {
    font-size: 14px;
    line-height: 1.4;
  }

  #top-nav-header .logo-box img {
    max-width: 65px;
    max-height: 60px;
  }
}</style>



// WEBPACK FOOTER //
// src/App.vue